import React from "react";
import { FaFilter, FaTimes } from "react-icons/fa";

import { getAdherentName, getGroupNames } from "../utils/coachStatsUtils";

function CoachStatsFilters({
  groups = [],
  adherents = [],
  filters,
  scopeLabel,
  onChange,
  onReset,
}) {
  return (
    <section className="rounded-[2rem] border border-white/80 bg-white/95 p-4 shadow-2xl shadow-slate-200/70 backdrop-blur-xl dark:border-white/10 dark:bg-slate-900/95 dark:shadow-black/30 sm:p-5">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <div className="inline-flex items-center gap-2 rounded-full bg-sky-100 px-3 py-2 text-xs font-bold uppercase tracking-[0.16em] text-sky-700 dark:bg-sky-500/10 dark:text-sky-200">
            <FaFilter />
            Filtres
          </div>

          <h2 className="mt-3 font-titre text-xl font-bold text-slate-950 dark:text-white">
            Vue actuelle : {scopeLabel}
          </h2>

          <p className="mt-1 text-sm font-medium text-slate-500 dark:text-white/50">
            Filtre par groupe ou par judoka pour analyser plus finement les
            résultats.
          </p>
        </div>

        <button
          type="button"
          onClick={onReset}
          className="inline-flex min-h-11 items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-4 py-2 text-xs font-bold text-slate-600 transition hover:border-red-200 hover:text-red-600 dark:border-white/10 dark:bg-white/[0.05] dark:text-white/70"
        >
          <FaTimes />
          Réinitialiser
        </button>
      </div>

      <div className="mt-5 grid gap-3 lg:grid-cols-2">
        <label className="block">
          <span className="mb-2 block text-xs font-bold uppercase tracking-[0.14em] text-slate-400">
            Groupe
          </span>

          <select
            value={filters.groupId}
            onChange={(event) => onChange("groupId", event.target.value)}
            disabled={Boolean(filters.adherentId)}
            className="h-12 w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 text-sm font-bold text-slate-700 outline-none transition focus:border-sky-300 focus:bg-white focus:ring-4 focus:ring-sky-100 disabled:cursor-not-allowed disabled:opacity-60 dark:border-white/10 dark:bg-slate-950 dark:text-white dark:focus:border-sky-300/50 dark:focus:ring-sky-500/10"
          >
            <option value="">Tous les groupes</option>
            {groups.map((group) => (
              <option key={group.id} value={group.id}>
                {group.nom}
              </option>
            ))}
          </select>
        </label>

        <label className="block">
          <span className="mb-2 block text-xs font-bold uppercase tracking-[0.14em] text-slate-400">
            Judoka
          </span>

          <select
            value={filters.adherentId}
            onChange={(event) => onChange("adherentId", event.target.value)}
            className="h-12 w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 text-sm font-bold text-slate-700 outline-none transition focus:border-sky-300 focus:bg-white focus:ring-4 focus:ring-sky-100 dark:border-white/10 dark:bg-slate-950 dark:text-white dark:focus:border-sky-300/50 dark:focus:ring-sky-500/10"
          >
            <option value="">Tous les judokas</option>
            {adherents.map((adherent) => (
              <option key={adherent.id} value={adherent.id}>
                {getAdherentName(adherent)} — {getGroupNames(adherent)}
              </option>
            ))}
          </select>
        </label>
      </div>
    </section>
  );
}

export default CoachStatsFilters;